export enum SegmentEvents {
    productFilterSorted = 'Product List Sorted',
    filterPriceSelected = 'Filter Price Selected',
    filterRentalPlanSelected = 'Filter Rental Plan Selected',
    filterProductAvailabilitySelected = 'Filter Product Availability Selected',
    filterBrandsSelected = 'Filter Brands Selected',
    filterSpecsSelected = 'Filter Specs Selected',
}
